// src/pages/About.js
import React, { useState } from "react";
import "./About.css";
import AboutPopUp from "../AboutPopUp";

function About() {
  const [popupData, setPopupData] = useState(null);

  const processData = [
    {
      id: 1,
      title: "On-Site Landscape Design & Walk-Throughs",
      content:
        "Greenview San Diego Hardscape is a licensed C-27 Landscape Contractor based in San Diego County (CSLB License #1141945). We meet homeowners on-site to walk the property, review drainage, elevation, and layout, and discuss ideas that align with both budget and long-term property value.",
      videoIndex: 1,
    },
    {
      id: 2,
      title: "Hardscape, Concrete & Paver Installation",
      content:
        "We specialize in hardscape construction including concrete flatwork, patios, walkways, pavers, and outdoor structural improvements. Each project is built with proper base preparation, grading, and reinforcement to ensure durability and long-term performance.",
      videoIndex: 2,
    },
    {
      id: 3,
      title: "Landscape Construction & Property Grading",
      content:
        "Our landscape construction services include grading, soil preparation, drainage solutions, planting, and yard reconfiguration. We focus on functional outdoor layouts that improve water flow, usability, and curb appeal.",
      videoIndex: 3,
    },
    {
      id: 4,
      title: "Property Clean-Ups & Yard Transformations",
      content:
        "Whether a property is overgrown, uneven, or outdated, Greenview San Diego Hardscape handles removals, demolition, grading, and full yard transformations. We leave the site clean, organized, and properly prepared for long-term landscaping success.",
      videoIndex: 4,
    },
    {
      id: 5,
      title: "Clear Estimates, Contracts & Scheduling",
      content:
        "Homeowners receive clear written estimates outlining scope of work, materials, timelines, and payment schedules. We communicate expectations upfront so there are no surprises during construction.",
      videoIndex: 5,
    },
    {
      id: 6,
      title: "Licensed, Insured & Code-Compliant Work",
      content:
        "Greenview San Diego Hardscape operates legally under CSLB License #1141945 as a C-27 Landscape Contractor. All work is performed in accordance with California building standards, proper bonding, and required insurance for homeowner protection.",
      videoIndex: 6,
    },
  ];

  const openPopup = (item) => setPopupData(item);
  const closePopup = () => setPopupData(null);

  return (
    <div className="about-page">
      <div className="about-container">
        <h1>About Greenview San Diego Hardscape</h1>

        <p>
          <strong>Greenview San Diego Hardscape</strong> is a California licensed
          <strong> C-27 Landscape Contractor</strong> serving San Diego County.
          Operating under CSLB License <strong>#1141945</strong>, our company
          specializes in hardscape construction, concrete, pavers, grading, and
          outdoor landscape improvements for residential properties.
        </p>

        <p>
          Every project is guided by a licensed contractor — from the initial
          site evaluation to final completion. We focus on proper planning,
          structural integrity, and clean workmanship to ensure outdoor spaces
          are built to last.
        </p>

        <h2>How We Work With Homeowners</h2>
        <p>
          Below is an overview of how we plan, manage, and complete each
          landscape construction project:
        </p>

        <ul className="process-list">
          {processData.map((item) => (
            <li key={item.id} onClick={() => openPopup(item)}>
              <strong>{item.title}:</strong>{" "}
              {item.content.substring(0, 80)}...
            </li>
          ))}
        </ul>

        <h2>Our Commitment</h2>
        <p>
          At <strong>Greenview San Diego Hardscape</strong>, we believe homeowners
          deserve honest communication, written clarity, and construction that
          meets California standards. We treat every property with respect and
          focus on building outdoor spaces that add value, functionality, and
          long-term reliability.
        </p>
      </div>

      {popupData && (
        <AboutPopUp
          onClose={closePopup}
          title={popupData.title}
          content={popupData.content}
          videoIndex={popupData.videoIndex}
        />
      )}
    </div>
  );
}

export default About;